import { FileDefinitionDTO } from "../DTO/fileDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateFileDefinitionRequest extends BasicRequest{
   
    public fileDefinition! : FileDefinitionDTO;
    
    constructor(){
        super();
    }
}